import styled from 'styled-components/macro';
import { Typography } from '@mui/material';

const Content = styled.div`
  position: relative;
`;

const TextWrapper = styled.div`
  position: relative;
  z-index: 1;
`;

const TextElement = styled(Typography)`
  margin-bottom: 20px;
  text-align: left;
  ${(props) => props.theme.breakpoints.up('lg')} {
    margin-bottom: 12px;
  }
`;

export const DidYouKnowStyles = {
  Content,
  TextElement,
  TextWrapper,
};
